<script>
  import { onMount } from 'svelte';
  import Conexoes from '../Classes/Conexoes.js';
  import Constantes from '../Classes/Constantes.js';
  import LoadingTela from '../componentes_basicos/LoadingTela.svelte';
  import CaixaDeDialogo from '../componentes_basicos/CaixaDeDialogo.svelte';

  export let slug = '';

  const conexao = new Conexoes();
  let isLoading = false;
  let mensagem = '';
  let mensagemSucesso = '';
  let dialogButton2Label = '';
  let dialogButton2Action = () => {};
  let horarios = [];
  let horarioSelecionado = null;
  let etapa = 'lista'; // 'lista' | 'form' | 'sucesso'

  let dadosAgendamento = { nome: '', ddd: '', telefone: '', email: '', cpf: '', endereco: '', dataNascimento: '', data: '', hora: '', id: '', observacoes: '' };
  let observacoesLabel = 'Observações';
  let diaNascimento = ''; let mesNascimento = ''; let anoNascimento = '';

  let agendamentoExistente = null;
  let ignorarReagendamento = false;
  let dialogButton1Label = 'Ok';
  let dialogButton1Action = () => { limparMensagemDialogo(); };

  let locaisDisponiveis = [];
  let localSelecionado = '';
  // Mostra 7 datas por vez (antes era uma lista longa dentro de uma caixa com rolagem própria)
  let datasVisiveis = 7;
  let locaisConfigPorNome = {};
  let tenantConfig = null;
  let configCampos = { email: 'opcional', cpf: 'oculto', nascimento: 'obrigatorio', endereco: 'oculto', observacoes: 'oculto' };
  let profissional = null; // Armazena dados do profissional para o cabeçalho

  const diasDaSemana = ['Domingo','Segunda-feira','Terça-feira','Quarta-feira','Quinta-feira','Sexta-feira','Sábado'];
  const configPadrao = { email: 'opcional', cpf: 'oculto', nascimento: 'obrigatorio', endereco: 'oculto', observacoes: 'oculto' };

  onMount(carregarDadosIniciais);

  function montarConfigCampos(localConfig = null) {
    const base = localConfig || {};

    return {
      email: base.campo_email || (tenantConfig && tenantConfig.campo_email) || configPadrao.email,
      cpf: base.campo_cpf || (tenantConfig && tenantConfig.campo_cpf) || configPadrao.cpf,
      nascimento: base.campo_nascimento || (tenantConfig && tenantConfig.campo_nascimento) || configPadrao.nascimento,
      endereco: base.campo_endereco || (tenantConfig && tenantConfig.campo_endereco) || configPadrao.endereco,
      observacoes: base.campo_observacoes || (tenantConfig && tenantConfig.campo_observacoes) || configPadrao.observacoes
    };
  }

  function aplicarConfigDeLocal() {
    const localConfig = localSelecionado ? locaisConfigPorNome[localSelecionado] : null;
    configCampos = montarConfigCampos(localConfig);
    observacoesLabel = (localConfig && localConfig.label_observacoes) || (tenantConfig && tenantConfig.label_observacoes) || 'Observações';
  }

  async function carregarDadosIniciais() {
    isLoading = true;

    // 1. Carrega configurações do profissional e dados básicos
    const urlConfig = Constantes.api_acesso.replace('acesso.php', 'obter_config_publica.php');
    const respostaConfig = await conexao.conecta(urlConfig, { body: { slug } });

    if (respostaConfig && respostaConfig.sucesso) {
      profissional = respostaConfig.tenant;
      tenantConfig = respostaConfig.tenant;
      locaisConfigPorNome = respostaConfig.locais_config_por_nome || {};
      // label de observações personalizável
      observacoesLabel = tenantConfig.label_observacoes || 'Observações';
      
      // Conversão forçada para Number() para evitar que JavaScript confunda string com inteiro
      const isAtivo = Number(profissional.ativo);
      const diasRestantes = Number(profissional.dias_restantes);

      // === TRAVA DE ASSINATURA BLINDADA ===
      if (isAtivo === 0 || diasRestantes <= 0) {
        etapa = 'inativo';
        isLoading = false;
        return; // Interrompe a execução aqui, nem chega a buscar os horários
      }
    } else {
      tenantConfig = null;
      locaisConfigPorNome = {};
    }

    // 2. Carrega os horários
    const respostaHorarios = await conexao.conecta(Constantes.api_listar_horarios, { body: { slug } });
    horarios = respostaHorarios || [];

    locaisDisponiveis = [...new Set(horarios.map(h => h.local || 'Consultório'))].sort();
    
    // LÓGICA INTELIGENTE DE LOCAL: 
    // Se só houver 1 local, já seleciona direto. Se houver mais de 1, deixa em branco para obrigar a escolha.
    if (locaisDisponiveis.length === 1) {
      localSelecionado = locaisDisponiveis[0];
    } else {
      localSelecionado = '';
    }

    aplicarConfigDeLocal();
    isLoading = false;
  }

  $: horariosFiltrados = horarios.filter(h => (h.local || 'Consultório') === localSelecionado);
  $: if (localSelecionado !== undefined) {
    aplicarConfigDeLocal();
  }

  function agruparPorData(lista) {
    return lista.reduce((acc, h) => {
      const data = h.inicio.split(' ')[0];
      if (!acc[data]) acc[data] = [];
      acc[data].push(h);
      return acc;
    }, {});
  }

  // Link "Adicionar ao Google Agenda" para o cliente não esquecer o horário
  function linkGoogleAgenda() {
    try {
      const data = String(dadosAgendamento.data || '').replace(/-/g, '');
      const hora = String(dadosAgendamento.hora || '').substring(0, 5);
      if (!data || !hora) return '';
      const [h, m] = hora.split(':').map(Number);
      let duracao = 60;
      if (horarioSelecionado?.inicio && horarioSelecionado?.fim) {
        const ini = new Date(String(horarioSelecionado.inicio).replace(' ', 'T'));
        const fim = new Date(String(horarioSelecionado.fim).replace(' ', 'T'));
        if (!isNaN(ini) && !isNaN(fim) && fim > ini) duracao = Math.round((fim - ini) / 60000);
      }
      const totalFim = h * 60 + m + duracao;
      const z = n => String(n).padStart(2, '0');
      const inicio = `${data}T${z(h)}${z(m)}00`;
      const fimStr = `${data}T${z(Math.floor(totalFim / 60) % 24)}${z(totalFim % 60)}00`;
      const titulo = `Horário com ${profissional?.nome || 'profissional'}`;
      const detalhes = `Agendado pelo link ${window.location.href}`;
      return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(titulo)}&dates=${inicio}/${fimStr}&ctz=America/Sao_Paulo&details=${encodeURIComponent(detalhes)}&location=${encodeURIComponent(localSelecionado || '')}`;
    } catch (e) { return ''; }
  }

  function linkWhatsProfissional() {
    const numero = String(profissional?.telefone || '').replace(/\D/g, '');
    if (numero.length < 10) return '';
    const comPais = numero.startsWith('55') && numero.length > 11 ? numero : '55' + numero;
    const texto = `Olá! Acabei de agendar pelo seu link para ${formatarData(dadosAgendamento.data)} às ${String(dadosAgendamento.hora).substring(0, 5)}.`;
    return `https://wa.me/${comPais}?text=${encodeURIComponent(texto)}`;
  }

  function formatarData(str) {
    const [ano, mes, dia] = str.split('-');
    return `${dia}/${mes}/${ano}`;
  }

  function getDiaDaSemana(str) {
    const [ano, mes, dia] = str.split('-').map(Number);
    return diasDaSemana[new Date(ano, mes - 1, dia).getDay()];
  }

  function limparMensagemDialogo() {
    mensagem = '';
    dialogButton1Label = 'Ok';
    dialogButton1Action = () => { limparMensagemDialogo(); };
    dialogButton2Label = '';
    dialogButton2Action = () => {};
    agendamentoExistente = null;
  }

  function mostrarDialogoReagendamento(agendamento) {
    const [data, hora] = [agendamento.data_hora.split(' ')[0], agendamento.data_hora.split(' ')[1].substring(0,5)];
    mensagem = `Já existe um agendamento futuro marcado para <strong>${formatarData(data)} às ${hora}</strong> com estes mesmos dados. Deseja remarcar e liberar o horário antigo?`;
    dialogButton1Label = 'Não, manter o atual';
    dialogButton1Action = () => {
      ignorarReagendamento = true;
      limparMensagemDialogo();
    };
    dialogButton2Label = 'Sim, remarcar';
    dialogButton2Action = confirmarReagendamento;
  }

  async function confirmarReagendamento() {
    if (!agendamentoExistente || !dadosAgendamento.id) return;
    const tenantId = (profissional && profissional.id) ? profissional.id : (tenantConfig && tenantConfig.id ? tenantConfig.id : '');
    if (!tenantId) {
      mensagem = 'Não foi possível identificar o profissional para a remarcação.';
      return;
    }
    isLoading = true;
    const resposta = await conexao.conecta(Constantes.api_reagendar_agendamento, {
      body: {
        id_tenant: tenantId,
        id_agendamento: agendamentoExistente.id,
        novo_id_horario: dadosAgendamento.id,
        restaurar_antigo: 1
      }
    });
    isLoading = false;

    if (resposta && resposta.sucesso) {
      mensagemSucesso = resposta.mensagem || 'Agendamento remarcado com sucesso!';
      etapa = 'sucesso';
      limparMensagemDialogo();
      agendamentoExistente = null;
      ignorarReagendamento = false;
    } else {
      mensagem = (resposta && resposta.mensagem) || Constantes.msg_erro_conexao_bd;
      limparMensagemDialogo();
    }
  }

  async function verificarAgendamentoExistente(telefoneCompleto) {
    const resposta = await conexao.conecta(Constantes.api_checar_reagendamento, {
      body: {
        slug,
        nome_cliente: dadosAgendamento.nome,
        telefone: telefoneCompleto,
        email: dadosAgendamento.email || '',
        cpf: dadosAgendamento.cpf || ''
      }
    });

    if (resposta && resposta.sucesso && resposta.tem_reagendamento) {
      agendamentoExistente = resposta.agendamento;
      mostrarDialogoReagendamento(agendamentoExistente);
      return true;
    }
    return false;
  }

  function selecionarHorario(h) {
    horarioSelecionado = h;
    dadosAgendamento.data = h.inicio.split(' ')[0];
    dadosAgendamento.hora = h.inicio.split(' ')[1];
    dadosAgendamento.id = h.id;
    etapa = 'form';
  }

  function voltarLista() { 
    etapa = 'lista';
    horarioSelecionado = null;
    limparMensagemDialogo();
  }

  async function confirmarAgendamento() {
    if (!dadosAgendamento.nome) { mensagem = 'Preencha o nome completo.'; return; }
    if (!dadosAgendamento.ddd || !/^\d{2}$/.test(dadosAgendamento.ddd)) { mensagem = 'DDD inválido (2 dígitos).'; return; }
    if (!dadosAgendamento.telefone || !/^\d{9,10}$/.test(dadosAgendamento.telefone)) { mensagem = 'Telefone inválido.'; return; }

    const telefoneCompleto = dadosAgendamento.ddd + dadosAgendamento.telefone;
    if (!ignorarReagendamento && !agendamentoExistente) {
      isLoading = true;
      const duplicado = await verificarAgendamentoExistente(telefoneCompleto);
      isLoading = false;
      if (duplicado) return;
    }

    if (configCampos.nascimento === 'obrigatorio' && (!diaNascimento || !mesNascimento || !anoNascimento)) { 
      mensagem = 'Preencha a data de nascimento completa.'; return; 
    }
    if (configCampos.email === 'obrigatorio' && !dadosAgendamento.email) { 
      mensagem = 'O E-mail é obrigatório.'; return; 
    }
    if (configCampos.cpf === 'obrigatorio' && !dadosAgendamento.cpf) { 
      mensagem = 'O CPF é obrigatório.'; return; 
    }
    if (configCampos.endereco === 'obrigatorio' && !dadosAgendamento.endereco) { 
      mensagem = 'O Endereço é obrigatório.'; return; 
    }
    if (configCampos.observacoes === 'obrigatorio' && !dadosAgendamento.observacoes) {
      mensagem = `${observacoesLabel} é obrigatório.`; return;
    }

    if (diaNascimento && mesNascimento && anoNascimento) {
      dadosAgendamento.dataNascimento = `${anoNascimento}-${mesNascimento}-${diaNascimento}`;
    }

    isLoading = true;
    const resposta = await conexao.conecta(Constantes.api_agendar, {
      body: { ...dadosAgendamento, slug, telefone: telefoneCompleto, observacoes: dadosAgendamento.observacoes }
    });
    isLoading = false;

    if (resposta && resposta.sucesso) {
      mensagemSucesso = resposta.mensagem || 'Agendamento realizado com sucesso!';
      etapa = 'sucesso';
      limparMensagemDialogo();
    } else {
      mensagem = (resposta && resposta.mensagem) || Constantes.msg_erro_conexao_bd;
      if (((resposta && resposta.mensagem) || '').toLowerCase().includes('reservado')) {
        dialogButton2Label = 'Tentar outro horário';
        dialogButton2Action = tentarOutroHorario;
      } else {
        dialogButton2Label = '';
        dialogButton2Action = () => {};
      }
    }
  }
</script>

<svelte:head>
  <title>{profissional?.nome ? `Agende com ${profissional.nome} | Hora na Mão` : 'Agendamento online | Hora na Mão'}</title>
  <meta name="description" content={profissional?.nome ? `Escolha um horário e agende online com ${profissional.nome}. Rápido, sem precisar ligar ou mandar mensagem.` : 'Agende seu horário online em poucos cliques.'} />
  <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800&display=swap" rel="stylesheet">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css">
</svelte:head>

<LoadingTela {isLoading} />
<CaixaDeDialogo
  message={mensagem}
  button1Label={dialogButton1Label}
  button1Action={dialogButton1Action}
  button2Label={dialogButton2Label}
  button2Action={dialogButton2Action}
/>

<div class="public-booking-container" style="--primary: {profissional?.cor_primaria || '#4a6c56'};">
  <div class="booking-card fade-in">
    
    {#if profissional}
      <div class="brand-header">
        
        <div class="brand-avatar {profissional.logo_url ? 'has-logo' : ''}">
          {#if profissional.logo_url}
            <img src={profissional.logo_url} alt="Logo" />
          {:else}
            <span class="avatar-iniciais">{(profissional.nome || '?').trim().split(/\s+/).slice(0, 2).map(p => p[0]).join('').toUpperCase()}</span>
          {/if}
        </div>
        
        <h2>{profissional.nome || 'Agendamento Online'}</h2>
        <p class="texto-bio">{profissional.texto_publico || 'Selecione o melhor horário para o seu atendimento'}</p>
      </div>
    {/if}

    <div class="card-body">
      
      {#if etapa === 'lista'}
        
        <!-- Com um só atendimento, não faz sentido pedir para escolher: mostramos só o nome -->
        {#if locaisDisponiveis.length > 1}
          <div class="input-group">
            <label>1. Escolha o atendimento:</label>
            <select class="select-modern" bind:value={localSelecionado} on:change={() => datasVisiveis = 7}>
              <option value="">Escolha uma opção...</option>
              {#each locaisDisponiveis as loc}
                <option value={loc}>{loc}</option>
              {/each}
            </select>
          </div>
        {:else if localSelecionado}
          <p class="local-unico"><i class="fas fa-map-marker-alt"></i> {localSelecionado}</p>
          <p class="titulo-horarios">Escolha um horário:</p>
        {/if}

        <div class="lista-horarios mt-4">
          {#if !localSelecionado}
            <div class="empty-state">
              <i class="fas fa-list-ul"></i>
              <p>Escolha o atendimento acima para ver os horários livres.</p>
            </div>
          {:else if horariosFiltrados.length === 0}
            <div class="empty-state">
              <i class="far fa-calendar-times"></i>
              <p>Não há horários livres no momento. Tente de novo mais tarde ou fale direto com o profissional.</p>
            </div>
          {:else}
            {@const grupos = Object.entries(agruparPorData(horariosFiltrados))}
            {#each grupos.slice(0, datasVisiveis) as [data, lista]}
              <div class="date-group fade-in">
                <div class="date-header">
                  <span class="date-main">{formatarData(data)}</span>
                  <span class="date-sub">{getDiaDaSemana(data)}</span>
                </div>
                <div class="time-grid">
                  {#each lista as h}
                    <button class="time-slot" on:click={() => selecionarHorario(h)}>
                      {h.inicio.split(' ')[1].substring(0,5)}
                    </button>
                  {/each}
                </div>
              </div>
            {/each}
            {#if grupos.length > datasVisiveis}
              <button class="btn-mais-datas" on:click={() => datasVisiveis += 7}>Ver mais datas</button>
            {/if}
          {/if}
        </div>
      {/if}

      {#if etapa === 'form'}
        <div class="form-header fade-in">
          <button class="btn-back" on:click={voltarLista}><i class="fas fa-arrow-left"></i> Voltar</button>
          <h3>Seus Dados</h3>
          <div class="selected-info">
            <i class="far fa-calendar-check"></i>
            <span>{formatarData(dadosAgendamento.data)} às {dadosAgendamento.hora.substring(0,5)}</span>
            <span class="badge presencial">{localSelecionado}</span>
          </div>
        </div>

        <div class="form-body fade-in">
          
          <div class="input-group">
            <label>Nome Completo *</label>
            <input type="text" class="input-modern" bind:value={dadosAgendamento.nome} placeholder="Como prefere ser chamado?" />
          </div>

          {#if configCampos.nascimento !== 'oculto'}
            <label class="block-label">Data de Nascimento {configCampos.nascimento === 'obrigatorio' ? '*' : ''}</label>
            <div class="row-inputs mb-3">
              <select class="select-modern" bind:value={diaNascimento}>
                <option value="">Dia</option>
                {#each Array(31).fill(0).map((_,i)=>i+1) as d}
                  <option value={d.toString().padStart(2,'0')}>{d.toString().padStart(2,'0')}</option>
                {/each}
              </select>
              <select class="select-modern" bind:value={mesNascimento}>
                <option value="">Mês</option>
                {#each Array(12).fill(0).map((_,i)=>i+1) as m}
                  <option value={m.toString().padStart(2,'0')}>{m.toString().padStart(2,'0')}</option>
                {/each}
              </select>
              <select class="select-modern" bind:value={anoNascimento}>
                <option value="">Ano</option>
                {#each Array(new Date().getFullYear()-1900+1).fill(0).map((_,i)=>new Date().getFullYear()-i) as a}
                  <option value={a}>{a}</option>
                {/each}
              </select>
            </div>
          {/if}

          <div class="row-inputs mb-3">
            <div class="input-group ddd-input">
              <label>DDD *</label>
              <input type="tel" class="input-modern" maxlength="2" bind:value={dadosAgendamento.ddd} placeholder="83" />
            </div>
            <div class="input-group telefone-input">
              <label>WhatsApp / Celular *</label>
              <input type="tel" class="input-modern" maxlength="10" bind:value={dadosAgendamento.telefone} placeholder="900000000" />
            </div>
          </div>

          {#if configCampos.email !== 'oculto'}
            <div class="input-group">
              <label>E-mail {configCampos.email === 'obrigatorio' ? '*' : '(opcional)'}</label>
              <input type="email" class="input-modern" bind:value={dadosAgendamento.email} placeholder="seu@email.com" />
            </div>
          {/if}

          {#if configCampos.cpf !== 'oculto'}
            <div class="input-group">
              <label>CPF {configCampos.cpf === 'obrigatorio' ? '*' : '(opcional)'}</label>
              <input type="text" class="input-modern" bind:value={dadosAgendamento.cpf} placeholder="000.000.000-00" />
            </div>
          {/if}

          {#if configCampos.endereco !== 'oculto'}
            <div class="input-group mb-4">
              <label>Endereço Residencial {configCampos.endereco === 'obrigatorio' ? '*' : '(opcional)'}</label>
              <input type="text" class="input-modern" bind:value={dadosAgendamento.endereco} placeholder="Rua, número, complemento..." />
            </div>
          {/if}

          {#if configCampos.observacoes !== 'oculto'}
            <div class="input-group mb-3">
              <label>{observacoesLabel}{configCampos.observacoes === 'obrigatorio' ? ' *' : ' (opcional)'}</label>
              <textarea class="input-modern" rows="3" bind:value={dadosAgendamento.observacoes} placeholder={observacoesLabel} required={configCampos.observacoes === 'obrigatorio'}></textarea>
            </div>
          {/if}

          <button class="btn-primary w-100 mt-4" on:click={confirmarAgendamento}>
            Confirmar Agendamento <i class="fas fa-check"></i>
          </button>
        </div>
      {/if}

      {#if etapa === 'sucesso'}
        <div class="success-state fade-in">
          <div class="icon-circle">
            <i class="fas fa-check"></i>
          </div>
          <h3>Tudo Certo!</h3>
          <p>{mensagemSucesso}</p>
          
          <div class="summary-box">
            <p><strong>{dadosAgendamento.nome}</strong></p>
            <p>{formatarData(dadosAgendamento.data)} às {dadosAgendamento.hora.substring(0,5)}</p>
            <p><strong>Local:</strong> {localSelecionado}</p>
          </div>

          {#if linkGoogleAgenda()}
            <a class="btn-acao-sucesso" href={linkGoogleAgenda()} target="_blank" rel="noopener"><i class="far fa-calendar-plus"></i> Adicionar à minha agenda (Google)</a>
          {/if}
          {#if linkWhatsProfissional()}
            <a class="btn-acao-sucesso whatsapp" href={linkWhatsProfissional()} target="_blank" rel="noopener"><i class="fab fa-whatsapp"></i> Falar com {String(profissional?.nome || 'o profissional').split(' ')[0]} no WhatsApp</a>
          {/if}
          {#if dadosAgendamento.email}
            <p class="aviso-email">Você vai receber a confirmação por e-mail e um lembrete na véspera.</p>
          {/if}

          <button class="btn-outline w-100" on:click={() => { etapa='lista'; carregarDadosIniciais(); }}>
            Fazer outro agendamento
          </button>
        </div>
      {/if}

      <!-- Rodapé discreto: antes era um anúncio do Hora na Mão para os clientes do profissional -->
      <div class="cta-footer">
        <a href="/?utm_source=agenda_publica&utm_medium=referral&utm_campaign=rodape_agenda" class="cta-link">Agenda online por <strong>Hora na Mão</strong></a>
      </div>

      {#if etapa === 'inativo'}
        <div class="empty-state fade-in" style="padding: 50px 20px;">
          <div class="icon-circle" style="background: #fed7d7; color: #e53e3e;">
            <i class="fas fa-calendar-times"></i>
          </div>
          <h3 style="color: var(--text-main); margin: 15px 0; font-weight: 800;">Agenda Temporariamente Indisponível</h3>
          <p style="font-size: 1.05rem; line-height: 1.6;">
            Os agendamentos online para <strong>{profissional?.nome || 'este profissional'}</strong> estão suspensos no momento. 
            <br><br>
            Por favor, entre em contato diretamente com o profissional pelo WhatsApp ou telefone para marcar seu horário.
          </p>
        </div>
      {/if}

    </div>
  </div>
</div>

<style>
  :root {
    --primary: #4a6c56;
    --primary-dark: #3a5443;
    --secondary: #d4e0d7;
    --secondary-light: #eef5f0;
    --accent: #cfaa6c;
    --accent-hover: #b8955a;
    --bg-app: #f4f7f5;
    --text-main: #2c3e34;
    --text-muted: #738a7c;
    --border: #e0e6e2;
  }

  * { box-sizing: border-box; }

  .public-booking-container {
    min-height: 100vh;
    background-color: var(--bg-app);
    font-family: 'Montserrat', sans-serif;
    color: var(--text-main);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 40px 20px;
  }

  .booking-card {
    background: #fff;
    border-radius: 16px;
    width: 100%;
    max-width: 500px;
    box-shadow: 0 10px 40px rgba(0,0,0,0.08);
    overflow: hidden;
    border-top: 6px solid var(--primary);
  }

  .brand-header {
    background: var(--secondary-light);
    padding: 30px 20px;
    text-align: center;
    border-bottom: 1px solid var(--border);
  }

  /* ESTILO PADRÃO (Ícone ou Foto Redonda Genérica) */
  .brand-avatar {
    width: 70px;
    height: 70px;
    background: var(--primary);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    margin: 0 auto 15px auto;
    box-shadow: 0 4px 10px rgba(74, 108, 86, 0.2);
    overflow: hidden;
  }

  /* ESTILO ESPECÍFICO PARA QUANDO TEM LOGO CADASTRADA */
  .brand-avatar.has-logo {
    width: 130px; /* Bem maior */
    height: 100px; /* Formato retangular flexível */
    background: transparent; /* Sem a cor de fundo primária */
    box-shadow: none; /* Sem a sombra circular invisível */
    border-radius: 0; /* Remove a máscara que cortava logos retangulares */
  }

  .brand-avatar.has-logo img {
    width: 100%;
    height: 100%;
    object-fit: contain; /* Contain garante que a logo não sofra cortes nem estique */
  }

  .brand-header h2 { margin: 0; font-size: 1.4rem; font-weight: 800; color: var(--primary); }
  .brand-header p { margin: 5px 0 0 0; font-size: 0.9rem; color: var(--text-muted); }

  .card-body { padding: 30px 25px; }

  /* LISTA DE HORÁRIOS */
  .local-unico { margin: 0 0 4px 0; font-weight: 700; color: var(--primary); font-size: 0.95rem; }
  .titulo-horarios { margin: 0; font-size: 0.9rem; color: var(--text-muted); }
  .btn-mais-datas { display: block; width: 100%; margin-top: 10px; padding: 12px; background: transparent; border: 1px dashed var(--border); border-radius: 10px; color: var(--primary); font-weight: 700; cursor: pointer; font-family: inherit; }
  .lista-horarios {
    padding-right: 5px;
  }
  
  .lista-horarios::-webkit-scrollbar { width: 6px; }
  .lista-horarios::-webkit-scrollbar-track { background: transparent; }
  .lista-horarios::-webkit-scrollbar-thumb { background: var(--secondary); border-radius: 10px; }

  .date-group { margin-bottom: 25px; }

  .date-header {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 12px;
    padding-bottom: 5px;
    border-bottom: 1px solid var(--border);
  }

  .date-main { font-weight: 700; color: var(--primary); font-size: 1.05rem; }
  .date-sub { font-size: 0.85rem; color: var(--text-muted); text-transform: uppercase; }

  .time-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 10px;
  }

  .time-slot {
    background: var(--bg-app);
    border: 1px solid var(--border);
    color: var(--text-main);
    padding: 12px 0;
    border-radius: 8px;
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.2s;
  }

  .time-slot:hover {
    background: var(--primary);
    color: white;
    border-color: var(--primary);
    transform: translateY(-2px);
  }

  /* FORMULÁRIO */
  .form-header { text-align: center; margin-bottom: 25px; position: relative; }
  
  .btn-back {
    position: absolute;
    left: 0;
    top: 0;
    background: none;
    border: none;
    color: var(--text-muted);
    font-weight: 600;
    font-size: 0.9rem;
    cursor: pointer;
  }
  .btn-back:hover { color: var(--primary); }

  .form-header h3 { margin: 0 0 15px 0; font-size: 1.2rem; font-weight: 800; color: var(--primary); }
  
  .selected-info {
    display: inline-flex; align-items: center; gap: 10px;
    background: var(--secondary-light); padding: 8px 15px;
    border-radius: 20px;
    font-size: 0.85rem; font-weight: 600; color: var(--primary);
  }

  .badge { padding: 3px 8px; border-radius: 12px; font-size: 0.75rem; }
  .badge.presencial { background: var(--accent); color: white; }

  .input-group { margin-bottom: 15px; display: flex; flex-direction: column; }
  .input-group label, .block-label { font-size: 0.85rem; font-weight: 700; color: var(--text-main); margin-bottom: 6px; display: block; text-align: left; }
  
  .input-modern, .select-modern {
    width: 100%; padding: 12px 15px; border: 1px solid var(--border);
    border-radius: 8px; font-family: inherit; font-size: 0.95rem;
    transition: border-color 0.2s; background: var(--bg-app);
  }
  .input-modern:focus, .select-modern:focus {
    outline: none; border-color: var(--primary); background: white;
    box-shadow: 0 0 0 3px rgba(74, 108, 86, 0.1);
  }

  .row-inputs { display: flex; gap: 10px; }
  .ddd-input { flex: 0 0 88px; }
  .telefone-input { flex: 1 1 auto; }
  .w-100 { width: 100%; }

  .btn-primary {
    background: var(--primary); color: white; border: none; padding: 14px;
    border-radius: 8px; font-weight: 700;
    font-size: 1rem; cursor: pointer;
    transition: background 0.3s;
  }
  .btn-primary:hover { background: var(--primary-dark); }
  
  .btn-outline {
    background: transparent; color: var(--primary); border: 2px solid var(--primary);
    padding: 12px;
    border-radius: 8px; font-weight: 700; cursor: pointer; transition: 0.3s;
  }
  .btn-outline:hover { background: var(--secondary-light); }

  /* SUCESSO */
  .success-state { text-align: center; padding: 20px 0; }
  .icon-circle {
    width: 80px; height: 80px; background: var(--secondary-light);
    color: var(--primary); border-radius: 50%; display: flex;
    align-items: center;
    justify-content: center; font-size: 2.5rem; margin: 0 auto 20px auto;
  }
  .success-state h3 { color: var(--primary); font-weight: 800; margin-bottom: 10px; }
  .summary-box {
    background: var(--bg-app); border: 1px dashed var(--border);
    padding: 15px; border-radius: 8px;
    margin: 20px 0; text-align: left;
  }
  .summary-box p { margin: 5px 0; font-size: 0.9rem; color: var(--text-main); }
  
  .empty-state { text-align: center; padding: 40px 20px; color: var(--text-muted); }
  .empty-state i { font-size: 2.5rem; color: var(--border); margin-bottom: 10px; }

  .cta-footer {
    text-align: center; padding: 20px 0; margin-top: 30px; border-top: 1px solid var(--border);
  }
  .cta-link {
    color: var(--text-muted); text-decoration: none; font-weight: 400; font-size: 0.8rem; opacity: 0.8;
    transition: color 0.3s;
  }
  .avatar-iniciais { font-size: 1.6rem; font-weight: 800; letter-spacing: 1px; }
  .btn-acao-sucesso { display: flex; align-items: center; justify-content: center; gap: 8px; width: 100%; box-sizing: border-box; margin: 0 0 10px 0; padding: 13px; border-radius: 10px; background: var(--primary); color: white; font-weight: 700; text-decoration: none; }
  .btn-acao-sucesso.whatsapp { background: #25d366; }
  .aviso-email { font-size: 0.85rem; color: var(--text-muted); margin: 4px 0 14px 0; }
  .cta-link:hover {
    color: var(--primary-dark); text-decoration: underline;
  }

  .fade-in { animation: fadeIn 0.3s ease-in-out; }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
  .mb-3 { margin-bottom: 15px; }
  .mt-4 { margin-top: 30px; }
  .texto-bio {
    white-space: pre-wrap;
    line-height: 1.6;
    margin-top: 10px;
  }

  @media (max-width: 640px) {
    .public-booking-container {
      padding: 16px;
      align-items: stretch;
    }

    .booking-card {
      max-width: none;
      border-radius: 12px;
    }

    .brand-header {
      padding: 24px 16px;
    }

    .brand-header h2 {
      font-size: 1.2rem;
    }

    .brand-avatar {
      width: 60px;
      height: 60px;
      font-size: 1.8rem;
    }

    .brand-avatar.has-logo {
      width: 110px;
      height: 80px;
    }

    .card-body {
      padding: 24px 16px;
    }

    .time-grid {
      grid-template-columns: repeat(auto-fit, minmax(78px, 1fr));
      gap: 8px;
    }

    .form-header {
      padding-top: 36px;
    }

    .btn-back {
      top: 0;
      left: 0;
    }

    .selected-info {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 8px;
    }

    .row-inputs {
      flex-direction: column;
    }

    .ddd-input {
      flex: 1 1 auto;
    }
  }
</style>